import K from '../constants/CollectionsConstants';
import BSMLogo from '../assets/logos/benito-santos-mexico.svg';

const init = {
    sectionSubtitle: null,
    sectionLogo: BSMLogo,
    collections: [],
    collection: {},
    coverCollections: []
};

export default function reducer(state = init, action) {
    switch (action.type) {
        case K.SET_SECTION_SUBTITLE:
            return {
                ...state,
                sectionSubtitle: action.payload
            };
        case K.SET_SECTION_LOGO:
            return {
                ...state,
                sectionLogo: action.payload
            };
        case K.GET_COLLECTION:
            return {
                ...state,
                collection: action.payload
            };
        case K.GET_COVER_COLLECTIONS:
            return {
                ...state,
                coverCollections: action.payload
            };
        case K.GET_COLLECTIONS:
            return {
                ...state,
                collections: action.payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/CollectionsReducer.js